import React from 'react';
import { Helmet } from "react-helmet";
import { FaCamera, FaLightbulb, FaEdit, FaShoppingBag, FaExpand, FaVideo } from 'react-icons/fa';
import "./ProductShoot.css";

const ProductShoot = () => {
  return (
    <main className="service-page">
      <Helmet>
        <title>Commercial Product Photography | Skyline Bussiness Solution</title>
        <meta name="description" content="High-fidelity product photography by Skyline Bussiness Solution at skylinebussinesssolutions.com. We capture the details that drive consumer trust and sales." />
        <link rel="canonical" href="https://skylinebussinesssolutions.com/product-shoot" />
      </Helmet>

      {/* 1. HERO SECTION */}
      <header className="service-hero">
        <div className="service-hero-content">
          <span className="service-badge">HIGH-FIDELITY IMAGERY</span>
          <h1 className="service-display">
            Premium <br />
            <span className="accent-text">Product Photography</span>
          </h1>
          <p className="service-intro">
            At <strong>Skyline Bussiness Solution</strong>, we don't just take pictures; we engineer 
            <strong> visual assets</strong>. Our studio captures the texture, depth, and soul of 
            your products to convert scrolling browsers into loyal buyers.
          </p>
        </div>
      </header>

      <div className="service-container">
        
        {/* 2. THE STUDIO PILLARS */}
        <section className="strategy-section">
          <div className="strategy-card">
            <div className="strat-icon"><FaLightbulb /></div>
            <h3>Cinematic Lighting</h3>
            <p>Using advanced strobe and continuous lighting setups to highlight material textures and eliminate unwanted reflections.</p>
          </div>
          <div className="strategy-card">
            <div className="strat-icon"><FaExpand /></div>
            <h3>Macro Precision</h3>
            <p>Capturing the ultra-fine details that build customer trust, from fabric weaves to intricate mechanical components.</p>
          </div>
          <div className="strategy-card">
            <div className="strat-icon"><FaEdit /></div>
            <h3>Post-Production</h3>
            <p>High-end retouching, color grading, and background manipulation to meet the strict standards of global marketplaces.</p>
          </div>
        </section>

        {/* 3. CAPABILITIES GRID */}
        <section className="capabilities-grid">
          <div className="glass-card">
            <FaShoppingBag className="card-icon" />
            <h3>E-commerce Catalog</h3>
            <p>Clean, high-white background shots optimized for Amazon, Flipkart, and Shopify storefronts.</p>
          </div>

          <div className="glass-card">
            <FaCamera className="card-icon" />
            <h3>Lifestyle & Editorial</h3>
            <p>Storytelling visuals that show your product "in the wild," perfect for high-engagement social media campaigns.</p>
          </div>

          <div className="glass-card">
            <FaVideo className="card-icon" />
            <h3>Motion Assets</h3>
            <p>Short-form product videos and 360° rotations designed to increase time-on-page and lower return rates.</p>
          </div>
        </section>

        {/* 4. THE STUDIO WORKFLOW */}
        <section className="workflow-section">
            <div className="section-header">
                <h2>The Studio Process</h2>
                <div className="line"></div>
            </div>
            <div className="workflow-steps">
                <div className="step">
                    <span>01</span>
                    <h4>Styling</h4>
                    <p>Preparing the product and set to ensure every angle is physically perfect before the shutter clicks.</p>
                </div>
                <div className="step">
                    <span>02</span>
                    <h4>Production</h4>
                    <p>High-resolution capture using industry-leading full-frame cameras and specialized lenses.</p>
                </div>
                <div className="step">
                    <span>03</span>
                    <h4>Curation</h4>
                    <p>Selecting and retouching the "Hero Shots" that will define your product's online presence.</p>
                </div>
            </div>
        </section>

        {/* CTA SECTION */}
        <section className="cta-section">
          <h2>Ready to Elevate Your Visuals?</h2>
          <p>Stop losing sales to low-quality images. Let's build your high-fidelity catalog today.</p>
          <button className="cta-btn">Book a Session</button>
        </section>
      </div>

      {/* SCHEMA */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Commercial Product Photography",
          "provider": {
            "@type": "Organization",
            "name": "Skyline Bussiness Solution",
            "url": "https://skylinebussinesssolutions.com"
          },
          "description": "Professional product photography and video services for e-commerce, advertising, and lifestyle marketing."
        })}
      </script>
    </main>
  );
};

export default ProductShoot;